import React, { useEffect } from "react";
// Component imports:
import Modal from "../../../ui-elements/Modal/Modal";
import { IPepType, PepWatchResponse } from "../../../types/PepTypes";
import { IKeldanApiResponse } from "../../../types/KeldanTypes";
import Table from "../../../ui-elements/Table/Table";
import { IPepArray, IPepData } from "../PepPage";
import Loading from "../../../ui-elements/Loading/Loading";
import { sortEntries } from "../DomesticSearch";
import Alert from "../../../ui-elements/Alert/Alert";
import Bugsnag from "@bugsnag/js";

interface IProps {
  show: boolean;
  close(): void;
  id?: string;
  //if we dont want to fetch data, we can pass it directly
  fetchedData?: IPepArray[];
}

const PepWatchPEPConnectionModal: React.FC<IProps> = ({ show, close, id, fetchedData }) => {
  const [data, setData] = React.useState<IPepData | null | Error>();
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/pep/GetPersonPepResponse?ssn=${id}`);

        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }

        const responseBody: IKeldanApiResponse<PepWatchResponse<IPepType>> = await response.json();
        if (
          responseBody.success &&
          responseBody.result &&
          responseBody.result.data.results &&
          responseBody.result.data.results[0]
        ) {
          // Sort the entries and set the data
          setData({
            name: responseBody.result.data.results[0].name,
            ssn: responseBody.result.data.results[0].ssn,
            connected: responseBody.result.data.results[0].connected,
            entries: sortEntries(responseBody.result.data.results ?? null),
          });
        }
      } catch (e) {
        if (e instanceof Error) {
          Bugsnag.notify(e);
          setData(new Error("Ekki tókst að sækja gögn um stjórnmálaleg tengsl (PEP). Vinsamlegast reyndu aftur síðar."))
        }
      } finally {
        setLoading(false);
      }
    };

    if (id && !fetchedData) {
      fetchData();
    }
  }, [id]); // Re-fetch when id changes

  const modalBody = () => {
    return (
      <div>
        <h3>Niðurstöður - Stjórnmálaleg tengsl (PEP)</h3>
        {loading ? (
          <Loading />
        ) : (data instanceof Error) ?
          <Alert type="error" headText={data.message} />
          : (
            <Table
              className="pep-connection-table"
              tableSize="lg"
              data={fetchedData ? fetchedData : data?.entries ?? []}
              columns={[
                {
                  title: "Aðili",
                  renderCell: ({ name }) => name,
                  textAlign: "left",
                },
                {
                  title: "Tengsl",
                  renderCell: ({ connection }) => connection,
                  textAlign: "left",
                },
                {
                  title: "Staða",
                  renderCell: ({ status }) => status,
                  textAlign: "left",
                },
                {
                  title: "Heimild",
                  renderCell: ({ source }) => source,
                  textAlign: "left",
                },
              ]}
            />
          )}
      </div>
    );
  };

  // Always return the Modal, even if data is undefined
  return <Modal className="pep-watch-modal" show={show} onHide={close} hasCloseButton body={modalBody()} />;
};

export default PepWatchPEPConnectionModal;
